import { combineEpics } from "redux-observable";
import { epicViewportCenter } from "./epics/epicViewportCenter";
import { epicViewportCloseModals } from "./epics/epicViewportCloseModals";
import { epicViewportResumeZoom } from "./epics/epicViewportResumeZoom";
import { epicViewportRewriteBuildingCenter } from "./epics/epicViewportRewriteBuildingCenter";
import { epicViewportZoom } from "./epics/epicViewportZoom";
export var epicViewportCore = combineEpics(epicViewportZoom, 
// epicViewportPauseZoom,
epicViewportResumeZoom, epicViewportCenter, epicViewportRewriteBuildingCenter, epicViewportCloseModals);



//////////////////
// WEBPACK FOOTER
// ./src/features/viewport/epicViewportCore.ts
// module id = 2498
// module chunks = 3